import moment, { Moment } from 'moment';

export const formatTime = (time: string | Date | Moment) => {
    return moment(time).format('hh:mm A');
};

export const formatDate = (time: string | Date | Moment) => {
    return moment(time).format('Do MMMM, YYYY');
};
